module.exports = __webpack_public_path__ + "static/media/iconEvaluation.ab13c9d9.svg";